<template>
    <transition name="fade">
        <div v-if="showing" class="fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center modal" style="z-index: 1000">
            <!--
              Background overlay, show/hide based on modal state.

              Entering: "ease-out duration-300"
                From: "opacity-0"
                To: "opacity-100"
              Leaving: "ease-in duration-200"
                From: "opacity-100"
                To: "opacity-0"
            -->
            <div class="fixed inset-0 transition-opacity">
                <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
            </div>

            <!--
              Modal panel, show/hide based on modal state.

              Entering: "ease-out duration-300"
                From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                To: "opacity-100 translate-y-0 sm:scale-100"
              Leaving: "ease-in duration-200"
                From: "opacity-100 translate-y-0 sm:scale-100"
                To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            -->
            <div class="bg-white rounded-lg overflow-hidden shadow-xl transform transition-all sm:w-full" role="dialog" :class="modalClasses" aria-modal="true" aria-labelledby="modal-headline">

                <div v-if="showClose" @click="$emit('close')" aria-label="close" class="cursor-pointer absolute top-0 right-0 text-xl text-gray-500 my-2 mx-4">
                    ×
                </div>

                <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4" :class="{'pb-4 sm:p-6 sm:pb-4': buttons.length, 'pb-6 sm:p-8 sm:pb-6': !buttons.length}">
                    <slot></slot>
                </div>
                <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse" v-if="buttons.length">
                    <span class="mt-3 flex w-full rounded-md shadow-sm sm:ml-3 sm:mt-0 sm:w-auto" v-for="button in buttons">
                        <button type="button" class="inline-flex justify-center w-full rounded-md border px-4 py-2 text-base leading-6 font-medium shadow-sm transition ease-in-out duration-150 focus:outline-none sm:text-sm sm:leading-5" :class="button.class ? button.class : 'bg-white text-gray-700 hover:text-gray-500 focus:border-blue-300 focus:shadow-outline-blue border-gray-300'" @click="button.onClick">
                          {{button.label}}
                        </button>
                    </span>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
    export default {
    	props: {
    		showing: {
    			type: Boolean,
    			default: false
            },
		    showClose: {
    			type: Boolean,
			    default: false
            },
		    buttons: {
			    type: Array,
			    default: []
		    },
            modalClasses: {
    			type: String,
                default: ''
            }
	    },
        data: () => {
    		return {}
        },
        methods: {

        }
    }
</script>
